module.exports = __webpack_public_path__ + "img/Grammar.2b13c6e9.jpg";